module.exports = __webpack_public_path__ + "static/media/photo-of-person-holding-alarm-clock.276ab66d.jpg";